import { useLazyQuery } from "@apollo/client/react";
import { MenuItem } from '@mui/material';
import { generateColumnsDefaultConfiguration } from '../../../components/dataGrid/columnHelpers';
import { TextInput } from '../../../components/textInput/TextInput';
import ClearIcon from '@mui/icons-material/Clear';
import SearchIcon from '@mui/icons-material/Search';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import { Box, FormControl, Grid, InputAdornment, InputLabel, OutlinedInput, Select, Stack, TextField } from '@mui/material';
import Chip from '@mui/material/Chip';
import { useTheme } from '@mui/material/styles';
import React, { useEffect, useRef, useState } from 'react';
import toast from 'react-hot-toast';
import DataGridGenerico from '../../../components/dataGrid/DataGridGenerico';
import { useForm } from '../../../components/hooks/useForm';

import { GET_PRODUCTS_BY_FILTERS } from '../../../data/graphQL/queries/Insumos/queries';
import { CustomDialog } from '../../../components/customDialog/CustomDialog';
import './tabContraindicaciones.scss';


export default function TabContraindicaciones({ idInsumo, alergias, listaAlergias, setListaAlergias, listaCompatibilidad, setListaCompatibilidad }) {

  const theme = useTheme();

  const [listaInsumosCompatibles, setListaInsumosCompatibles] = useState([]);

  const [compatibilidades, setCompatibilidades] = useState([]);
  const [compatibilidadesOriginal, setCompatibilidadesOriginal] = useState([]);

  const [openDlgCompatibilidades, setOpenDlgCompatibilidades] = useState(false);
  const txtFiltroCompatibilidad = useRef(null);
  const [loadingBuscarCompatibilidad, setLoadingBuscarCompatibilidad] = useState(false);
  const [rowSelectionModelDispo, setRowSelectionModelDispo] = useState([]);

  useEffect(() => {

    if (alergias.length > 0 && listaAlergias.length > 0) {
      setFormValues(
        {
          ...formValues,
          ComboAlergias: listaAlergias.map((x) => x.descripcion)
        });
    }

    getCompatibilidades({ variables: { idTipoInsumo: 0, descripcion: '' } });
  }, []);


  const [formValues, formHandle, reset, setFormValues] = useForm({
    ComboAlergias: []
  });


  function getStyles(name, personName, theme) {
    return {
      fontWeight:
      personName.indexOf(name) === -1 ?
      theme.typography.fontWeightRegular :
      theme.typography.fontWeightMedium
    };
  }

  const handleChangeComboAlergias = (event) => {
    const { target: { value } } = event;

    setFormValues(
      {
        ...formValues,
        ComboAlergias: typeof value === 'string' ? value.split(',') : value
      });
  };

  const [getCompatibilidades, { data: dataCompatibilidad }] = useLazyQuery(GET_PRODUCTS_BY_FILTERS, {
    fetchPolicy: 'no-cache'
  });

  useEffect(() => {
    if (!dataCompatibilidad) return;
    if (dataCompatibilidad.productoByFilters.success) {
      const lista = dataCompatibilidad.productoByFilters.valorEsperado;
      const listaFilter = lista.filter((x) => x.idInsumo != idInsumo);
      setCompatibilidades(listaFilter);
      setCompatibilidadesOriginal(listaFilter);
    };
  }, [dataCompatibilidad]);

  // handles de Dialog Compatibilidad
  const handleSearchCompatibilidades = () => {
    setOpenDlgCompatibilidades(true);
    setLoadingBuscarCompatibilidad(true);

    mergeSelectedCompatibilidad();
  };

  const mergeSelectedCompatibilidad = () => {
    let lista = compatibilidadesOriginal.filter((x) => {
      let resultado = listaCompatibilidad.find((y) => {
        return y.idInsumo == x.idInsumo;
      });
      return resultado == undefined;
    });

    setCompatibilidades(lista);
  };

  const handleSearchCompatibilidad = () => {
    // si se ingresó texto a buscar (al menos 3 caracteres) --> filtro, sino retorno todos los registros
    // originales consultados
    if (txtFiltroCompatibilidad.current.value != "") {
      if (txtFiltroCompatibilidad.current.value.length >= 3) {
        setCompatibilidades(compatibilidades.filter((compatibilidades) => {
          const insumoBuscar = compatibilidades.idInsumo.toLowerCase();
          const descripcionBuscar = compatibilidades.descripcion.toLowerCase();

          const inputBuscar = txtFiltroCompatibilidad.current.value;
          return (
            insumoBuscar.includes(inputBuscar) ||
            descripcionBuscar.includes(inputBuscar));

        }
        ));
      }
    } else {
      //setCompatibilidades(compatibilidadesOriginal);
      mergeSelectedCompatibilidad();
    }
  };

  const handleCleanCompatibilidad = () => {
    txtFiltroCompatibilidad.current.value = "";
    handleSearchCompatibilidad();
    txtFiltroCompatibilidad.current.focus();
  };

  const onRowsSelectionHandlerDispo = (ids) => {
    setRowSelectionModelDispo(ids);
  };

  const handleAceptarDlgNuevos = () => {
    if (rowSelectionModelDispo.length > 0) {
      let idsInsumo = [];
      rowSelectionModelDispo.map((index) => {
        const nodo = idsInsumo.filter((c) => c == compatibilidades[index - 1].idInsumo);
        idsInsumo.push(compatibilidades[index - 1].idInsumo);
      });

      let lista = compatibilidades.filter((x) => {
        let resultado = idsInsumo.find((y) => {
          return y == x.idInsumo;
        });
        return resultado != undefined;
      }).map((item) => {
        let obj = {
          idCompatibilidad: item.idInsumoN,
          idInsumo: item.idInsumo,
          descripcion: item.descripcion
        };

        return obj;
      });


      if (listaCompatibilidad.length <= 0)
      setListaCompatibilidad(lista);else
      {

        lista.forEach((element) => {
          setListaCompatibilidad((current) => [...current, element]);
        });
      }

      setOpenDlgCompatibilidades(false);
      setLoadingBuscarCompatibilidad(false);

    } else {
      toast.error("Debe seleccionar al menos un producto.");
    }
  };

  const handleCloseDlgCompatibilidad = () => {
    setOpenDlgCompatibilidades(false);
    setLoadingBuscarCompatibilidad(false);
  };

  const handleDeleteCompatibilidad = (row) => {
    let listado = listaCompatibilidad.filter((x) => x.idInsumo != row.idInsumo);

    setListaCompatibilidad((current) => [...listado]);
  };

  // generate columns grillas
  const initialColumnsCompatibilidadSelected = [
  {
    field: 'idInsumo',
    headerName: 'Código'
  },
  {
    field: 'descripcion',
    headerName: 'Descripción'
  },
  {
    headerName: '',
    field: 'action',
    flex: 0.02,
    renderCell: (params) => {
      const row = params.row;
      return (
        <>
                        <DeleteOutlineIcon
            className='edit-icon'
            titleAccess='Eliminar'
            onClick={() => handleDeleteCompatibilidad(params.row)} />
          
                    </>);

    }
  }];


  const columnsCompatibilidadSelected = generateColumnsDefaultConfiguration(initialColumnsCompatibilidadSelected);

  const initialColumnsCompatibilidad = [
  {
    field: 'idInsumo',
    headerName: 'Código'
  },
  {
    field: 'descripcion',
    headerName: 'Descripción'
  }];


  const columnsCompatibilidad = generateColumnsDefaultConfiguration(initialColumnsCompatibilidad);

  return (
    <>
            <Grid
        container
        justifyContent={'space-between'}
        columns={{
          xs: 2,
          md: 8
        }}
        spacing={3}>
        
 <Grid size={{ xs: 3.5 }}>
                    <div style={{ backgroundColor: 'white', padding: 10, borderRadius: 8 }}>
                        <h4>Contraindicaciones</h4>
                        <Stack direction="row" spacing={1} alignItems="center">
                            <FormControl sx={{ backgroundColor: 'white', width: '100%' }} size="small">
                                <InputLabel id="multiple-chip-label" sx={{ backgroundColor: 'white', width: 60 }}>Alergias</InputLabel>
                                <Select
                  labelId="multiple-chip-label"
                  id="multiple-chip"
                  multiple
                  value={formValues.ComboAlergias}
                  onChange={handleChangeComboAlergias}
                  onBlur={(e) => {
                    if (formValues.ComboAlergias.length > 0) {
                      let lista = alergias.filter((x) => {
                        let resultado = formValues.ComboAlergias.find((y) => {
                          return y == x.descripcion;
                        });
                        return resultado != undefined;
                      });

                      setListaAlergias(lista);
                    } else
                    {
                      setListaAlergias([]);
                    }
                  }
                  }
                  input={<OutlinedInput id="select-multiple-chip" label="Chip" />}
                  renderValue={(selected) =>
                  <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                                            {selected.map((value) =>
                    <Chip key={value} label={value} />
                    )}
                                        </Box>
                  }>
                  
                                    {alergias.map((alergia) =>
                  <MenuItem
                    key={alergia.idAlergia}
                    value={alergia.descripcion}
                    style={getStyles(alergia, formValues.ComboAlergias, theme)}>
                    
                                            {alergia.descripcion}
                                        </MenuItem>
                  )}
                                </Select>
                            </FormControl>
                        </Stack>
                    </div>
                </Grid>
 <Grid sx={{ boxSizing: 'border-box', width: '100%' }} size={{ xs: 4.5 }}>
                    <div style={{ backgroundColor: 'white', padding: 10, borderRadius: 8 }}>
                        <h4>Compatibilidades</h4>
                        <TextInput
              label='Buscar Insumo'
              searchIcon
              placeholder='Buscar Insumo'
              onClick={handleSearchCompatibilidades} />
            
                        <div style={{ marginTop: 10 }}>
                            <DataGridGenerico
                columns={columnsCompatibilidadSelected}
                fileNameExport='InsumosCompatibles'
                rows={listaCompatibilidad}
                toolbar={false}
                totalCount={listaCompatibilidad.length} />
              
                        </div>
                    </div>
                </Grid>
            </Grid>

            <CustomDialog
        maxWidth="lg"
        fullWidth={true}
        open={openDlgCompatibilidades}
        title={'Selecciona Compatibilidades'}
        onCancel={handleCloseDlgCompatibilidad}
        cancelText='Cerrar'
        onAccept={handleAceptarDlgNuevos}>
        
                <div style={{ display: 'flex', width: '100%' }}>
                    <FormControl sx={{ backgroundColor: 'white', width: 300 }} size="small">
                        <div style={{ display: 'flex', width: '100%' }}>
                            <TextField
                label="Filtrar"
                name="txtFiltroCompatibilidad"
                size="small"
                type="text"
                variant="outlined"
                inputRef={txtFiltroCompatibilidad}
                onKeyUp={handleSearchCompatibilidad}
                sx={{ backgroundColor: 'white' }}
                InputProps={{
                  endAdornment:
                  <InputAdornment position="end">
                                            <SearchIcon
                      onClick={handleSearchCompatibilidad}
                      sx={{ cursor: 'pointer' }} />
                    
                                            <ClearIcon
                      onClick={handleCleanCompatibilidad}
                      sx={{ cursor: 'pointer' }} />
                    
                                        </InputAdornment>

                }} />
              
                        </div>
                    </FormControl>
                </div>

                <br />

                <DataGridGenerico
          columns={columnsCompatibilidad}
          rows={compatibilidades && compatibilidades.map((item, index) => {return { id: index + 1, ...item };})}
          toolbar={false}
          checkboxSelection={true}
          disableSelectionOnClick
          onRowSelectionModelChange={(ids) => onRowsSelectionHandlerDispo(ids)}
          rowSelectionModel={rowSelectionModelDispo}
          getRowId={(row) => row._id}
          totalCount={compatibilidades.length} />
        
            </CustomDialog>
        </>);

}